import { FC } from 'react';
import { useAppSelector } from 'helpers/hooks';
import { useFieldValue } from 'hooks/useFormHelpers';
import { getRecipientsData } from 'selectors/recipients';
import { CartProcessingRedirect } from 'store/shoppingCart/types';
import { canAcceptDonationsThrough } from './compatibility';
import { PROCESSING_REDIRECT_OPTIONS } from './constants';

type Props = {
  recipientId: string;
};

export const RecipientCompatibilityBadge: FC<Props> = ({ recipientId }) => {
  const recipients = useAppSelector(getRecipientsData);
  const processingRedirect = useFieldValue('processing_redirect') as
    | CartProcessingRedirect
    | undefined;
  const recipient = recipients.find(rec => rec.recipient_id === recipientId);

  if (!recipient || canAcceptDonationsThrough(recipient, processingRedirect)) return null;

  const processorLabel = PROCESSING_REDIRECT_OPTIONS.find(
    option => option.value === processingRedirect
  )?.label;

  return (
    <span className="oath-utility gray padding-right4">
      {processorLabel ? `Can't accept ${processorLabel} donations` : 'Not compatible'}
    </span>
  );
};
